<template>
  <a-modal
      :open="open"
      class="modal-no-padding disable-subscription-modal"
      :width="400"
      @cancel="closeForm"
  >
    <div class="modal-no-padding__header">
      <h2>Отправить запрос на отключение?</h2>
    </div>

    <a-divider style="margin: 16px 0" />

    <div class="modal-no-padding__body disable-subscription-modal__body">
      Ответственный менеджер свяжется с вами в течение рабочего дня.
    </div>

    <template #footer>
      <a-divider style="margin: 16px 0" />

      <div class="modal-no-padding__footer">
        <a-row
            justify="end"
            :gutter="8"
        >
          <a-col>
            <a-button
                class="secondary-button"
                @click="closeForm"
            >
              Отменить
            </a-button>
          </a-col>

          <a-col>
            <a-button
                class="primary-button"
                @click="send"
            >
              Отправить
            </a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'DisableSubscriptionModal',
  props: {
    open: Boolean,
    name: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'done'],
  setup(props, context) {
    const closeForm = () => {
      context.emit('close');
    };

    const send = () => {
      context.emit('done');
    };

    return {
      closeForm,
      send,
    };
  },
};
</script>

<style scoped lang="scss">
.disable-subscription-modal__body {
  color: rgba(0, 0, 0, 0.55);
  font-size: 14px;
  line-height: 120%;
}
</style>
